import React, { useEffect, useMemo, useRef, useState } from "react";

import { API_BASE_URL } from "../../../../../api";
import { attachScormApiToWindow } from "./ScormApiBridge";

const buildScormIframeSrc = (launchUrl) => {
    if (!launchUrl) return "";

    const raw = String(launchUrl).trim();

    if (/^https?:\/\//i.test(raw)) {
        return raw;
    }

    const cleaned = raw.replace(/^\/+/, "");
    const base = String(API_BASE_URL || "").replace(/\/+$/, "");

    return `${base}/${cleaned}`;
};

const debugFrame = (message, payload = {}) => {
    if (process.env.NODE_ENV !== "production") {
        console.info("[SCORM Frame]", message, payload);
    }
};

export default function ScormLaunchFrame({ launchUrl, title, onLoad, onDiagnostics }) {
    const iframeRef = useRef(null);
    const iframeSrc = useMemo(() => buildScormIframeSrc(launchUrl), [launchUrl]);
    const [frameSrc, setFrameSrc] = useState("");

    useEffect(() => {
        const iframe = iframeRef.current;
        let cancelled = false;

        setFrameSrc("");
        debugFrame("Preparing iframe", {
            launchUrl,
            iframeSrc,
        });
        onDiagnostics?.({
            iframeSrc,
            iframeSameOrigin: null,
            iframeApiInjected: false,
        });

        const timer = window.setTimeout(() => {
            if (cancelled) return;
            const attached = attachScormApiToWindow(iframe?.contentWindow, window, "iframe:aboutblank");
            debugFrame("API bootstrap before src", { attached, iframeSrc });
            onDiagnostics?.({
                iframeSrc,
                iframeSameOrigin: attached,
                iframeApiInjected: attached,
            });
            setFrameSrc(iframeSrc);
        }, 0);

        return () => {
            cancelled = true;
            window.clearTimeout(timer);
        };
    }, [iframeSrc, launchUrl, onDiagnostics]);

    const handleLoad = () => {
        const iframe = iframeRef.current;
        const attached = attachScormApiToWindow(iframe?.contentWindow, window, "iframe:onload");
        debugFrame("Loaded iframe", {
            src: frameSrc,
            attached,
            sameOrigin: attached,
        });
        onDiagnostics?.({
            iframeSrc: frameSrc,
            iframeSameOrigin: attached,
            iframeApiInjected: attached,
        });
        if (frameSrc) {
            onLoad?.();
        }
    };

    return (
        <iframe
            ref={iframeRef}
            className="scorm-frame"
            title={title || "Contenu SCORM"}
            src={frameSrc}
            onLoad={handleLoad}
            allow="fullscreen; autoplay"
        />
    );
}
